import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from '../services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthenticationService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authService.isUserLogged()) {
      // if (isNullOrUndefined(this.userSessionService.getCurrentPage())) {
      //     this.userSessionService.setCurrentPage(state.url);
      // }
      this.router.navigate(['/login']).then();
      return false;
    } else {
      return true;
    }

  }
}
